export function eventBlockOverlapValidator($el) {
  const currentEventBlock = $el.closest(".event-block")[0];
  const eventBlocks = [...document.getElementById("blocks-container").querySelectorAll(".event-block:not(.hidden)")];
  const currentEventBlockFilled = blockDatesSelected(currentEventBlock);
  if (!currentEventBlockFilled) {
    return true;
  }
  const currentBlockStartAt = new Date(currentEventBlock.querySelector('input[name*="[start_at]"]').value);
  const currentBlockEndAt = new Date(currentEventBlock.querySelector('input[name*="[end_at]"]').value);
  let valid = true;
  eventBlocks.forEach((block) => {
    if (currentEventBlock === block) {
      return;
    }
    const eventBlockDatesFilled = blockDatesSelected(block);
    if (!eventBlockDatesFilled) {
      return;
    }
    const blockStartAt = new Date(block.querySelector('input[name*="[start_at]"]').value);
    const blockEndAt = new Date(block.querySelector('input[name*="[end_at]"]').value);
    if (currentBlockStartAt >= blockStartAt && currentBlockStartAt < blockEndAt || currentBlockEndAt > blockStartAt && currentBlockEndAt <= blockEndAt) {
      valid = false;
    }
  });
  return valid;
}
function blockDatesSelected(block) {
  const blockStartAtDate = block.querySelector('input[id*="start_at_date"]').value;
  const blockStartAtTime = block.querySelector('input[id*="start_at_time"]').value;
  const blockEndAtDate = block.querySelector('input[id*="end_at_date"]').value;
  const blockEndAtTime = block.querySelector('input[id*="end_at_time"]').value;
  return [blockStartAtDate, blockStartAtTime, blockEndAtDate, blockEndAtTime].every((value) => value);
}
Foundation.Abide.defaults.validators["event_block_overlap"] = eventBlockOverlapValidator;
